import styled from "styled-components";
import { keyframes } from "@emotion/react"; // IMPORTA DA EMOTION

export const Container = styled.div``;

export const Content = styled.div`
  max-width: 1440px;
  width: 100%;
  margin: 0 auto;
  padding: 30px 0;
`;

export const PageTitle = styled.h3`
  margin: 0 0 5px 0;
  padding: 0;
`;

export const PageDescription = styled.h3`
  margin: 0 0 10px 0;
  padding: 0;
`;

export const FormContainer = styled.form`
  padding: 40px;
  background-color: #fff;
  border-radius: 10px;
`;

export const Shake = keyframes`
  0% { transform: translateX(0); }
  20% { transform: translateX(-4px); }
  40% { transform: translateX(4px); }
  60% { transform: translateX(-4px); }
  80% { transform: translateX(4px); }
  100% { transform: translateX(0); }
`;

